module.exports = __webpack_public_path__ + "img/deflated.04d0924d.svg";